module.exports = __webpack_public_path__ + "static/media/no-apps.4ab7dbed.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/no-apps.png
// module id = 305
// module chunks = 0